export default "__VITE_ASSET__GRerqBcA__"